import { beginCartLinesUpdate, controllableLineForVariant, variantQuantity } from './standard-cart-events.js';
import { summarizeWsaioOutcomes } from './wsaio-operation-outcomes.js';

async function fetchCart() {
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`Unable to refresh cart (${response.status})`);
  return response.json();
}

window.CHStandardCartBridge = Object.freeze({
  controllableLineForVariant,
  summarizeOutcomes: summarizeWsaioOutcomes,
  variantQuantity,
  begin({ action, lines, source = 'wsaio', target = document }) {
    return beginCartLinesUpdate(target, {
      action,
      context: 'cart',
      lines,
      detail: { source, sourceId: source },
    });
  },
  /** @param {{resolve: (cart: any, detail?: Record<string, any>, userErrors?: Array<{code?: string, field?: string[], message: string}>) => void, reject: (error: unknown) => void} | null | undefined} update @param {Record<string, unknown>} [detail] @param {Array<{code?: string, field?: string[], message: string}>} [userErrors] */
  async resolve(update, detail = {}, userErrors = []) {
    if (!update) return null;
    const cart = await fetchCart();
    update.resolve(cart, { ...detail, itemCount: cart.item_count || 0 }, userErrors);
    return cart;
  },
  /** @param {{resolve: (cart: any, detail?: Record<string, any>) => void, reject: (error: unknown) => void} | null | undefined} update @param {unknown} error */
  reject(update, error) {
    update?.reject(error);
  },
});
